import React from "react";
import "./UnansweredHintComponent.scss";
import { useTranslation } from "react-i18next";

function UnansweredHintComponent({ accountType, phoneIsInvalid }) {
    const { t } = useTranslation();
    return (
        <div className="unanswered-warning">
            <span className={`warning warning-${accountType}`} />
            <p className="unanswered-warning-text">{phoneIsInvalid ? "Please enter a valid US phone number" : t("answer_warning_text")}</p>
        </div>
    );
}

export default UnansweredHintComponent;
